///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespace
//
///////////////////////////////////////////////////////////////////////////////////////////////////

// TODO: consolidate this using _form_wizard

abcsetup.front_store = abcsetup.front_store || {};
abcsetup.front_store.form = abcsetup.front_store.form || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.front_store.form.current_tab = null;


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.front_store.form = {
    init: function (editing = false) {
        const _this = this;
        this.current_tab = 0;

        // Offset the form field validator
        window.fieldValidate.offsetTop = 50;

        // Bind form events for specific fields
        this._bindFormEvents();

        // Left hand tab clicked
        $(document).on('click', 'a.form-tab-link', function () {
            var index = $('.bs-vertical-wizard li:visible').index($(this).closest('li'));

            // Select the specified item form tab
            _this._selectItemFormTab(index);

            $(this).blur();
            return false;
        });

        // Prev/Next tab button clicked
        $(document).on('click', 'a.page-link', function () {
            $('.bs-vertical-wizard li:visible').eq(_this.current_tab).removeClass('current');

            if ($(this).data('dir') == 'next') {
                // Validate the current tab
                if (_this._validateForm(_this.current_tab)) {
                    _this.current_tab++;
                }
            } else {
                _this.current_tab--;
            }

            // Select the specified item form tab
            _this._selectItemFormTab(_this.current_tab);

            return false;
        });

        // Validate tab button clicked
        $("button[value='validate']").on("click", function () {
            _this._validateForm(_this.current_tab);
            return false;
        });

        // Submit button clicked
        $("button[value='submit_to_cm']").on("click", function () {
            return !!_this._validateForm();
        });

        // Submit button clicked by GRx analyst
        $("button[value='submit_to_grx_cm']").on("click", function () {
            return !!_this._validateForm();
        });

        // Submit button clicked by GRx analyst
        $("button[value='grx_analyst_submit']").on("click", function () {
            return !!_this._validateFormGRxAnalyst();
        });

        // Submit button clicked bt GSMD
        $("button[value='gsmd_submit']").on("click", function () {
            return !!_this._validateForm();
        });

        // cm_approve
        // Submit approve button clicked by GRx analyst
        $("button[value='approve_grx_analyst']").on("click", function () {
            return !!_this._validateForm();
        });

        // Submit approve button clicked by Private Label Team
        $("button[value='approve']").on("click", function () {
            return !!_this._validateForm();
        });

        // Submit button clicked
        $("#maintenance_submit").on("click", function() {
            //console.log('submit: ');
            if (abcsetup.rx_item.form._validateForm()) {
                return true;
                //$('#hidden_submit').click();
            }
            return false;
        });

        $('.bs-vertical-wizard, .item-form-btns').show();

        // Init the form state when fields have been filed out -
        // TODO: Re-think this to just apply to the lefthand navs
        if (editing) {
            this._validateForm(null, true);
        }

        // Select the specified item form tab
        //this._selectItemFormTab(this.current_tab);
        this._selectItemFormTab(0);
    },


    /**
     * Bind form events for specific fields
     */
    _bindFormEvents: function () {
        // Shipping method changed
        $('#shipping_method').on("change", function () {
            var bracket_pricing_type = $("#bracket_pricing_type").val();

            $('#bracket_break_pricing td.uom').html($(this).val());
            //$('#bracket_break_pricing .bracket_dollars, #bracket_break_pricing .bracket_qty, #bracket_break_pricing .bracket_weight, #bracket_break_pricing .break').not('.view-only').val('');

            $('input[name*="bracket_break_pricing[' + bracket_pricing_type + '][1][min_price]"]').val(0);
            $('input[name*="bracket_break_pricing[' + bracket_pricing_type + '][1][max_price]"]').val(0);

            // Set the UOM Cost for bracket and break pricing
            abcsetup.front_store.form._setUomCost();

        }).trigger('change');

        $(document).on('change','#label_item', function() {
            let mat_descr = $('#mat_descr').val();
            let abbr_descr = $('#abbr_descr').val();
            if($(this).val() === 'Y') {
                mat_descr.replace(/LBL$/,'');
                abbr_descr.replace(/LBL$/,'');
                $('#mat_descr').val(mat_descr + ' LBL');
                $('#abbr_descr').val(abbr_descr + ' LBL');
                $('#wholesale_unit').val('EA').prop('disabled',true).before('<input id="wholesale_unit" class="wholesale_unit_hidden" type="hidden" name="wholesale_unit" value="EA" />');
                $('#drop_ship_warehouse').val('ZNSG');
                abcsetup.front_store.form._validateForm(abcsetup.front_store.form.current_tab);

            } else {
                $('#mat_descr').val(mat_descr.replace(/LBL$/,''));
                $('#abbr_descr').val(abbr_descr.replace(/LBL$/,''));
                $('.wholesale_unit_hidden').remove();
                $('#wholesale_unit').prop('disabled',false);
                $('#drop_ship_warehouse').val('');
                abcsetup.front_store.form._validateForm(abcsetup.front_store.form.current_tab);
            }
        });

        $(document).on('change', '#retail_remedies', function() {
            if($(this).val() === 'Y') {
                const d = new Date();
                d.setMonth(d.getMonth() + 4);
                const year = d.getFullYear();
                const month = ('0' + d.getMonth()).slice(-2);
                $('.rr_start_date_hidden').remove();
                $('#rr_start_date').val(year + '-' + month);
            }
            else {
                $('#rr_start_date').val("").before('<input id="rr_start_date" class="rr_start_date_hidden" type="hidden" name="rr_start_date" value="" />');
            }
        });

        $(document).on('change', '#pog_category', function() {
            axios.get('/api/front_store/pog_exec_date/'+$(this).val())
                .then((response) => {
                    $('#order_product_date').val(response.data.execution_date);
                });
        });

        $(document).on('change', '#display_event_prebook', function() {
            if($(this).val() === 'Y') {
                $('#dc_order_quantity').val('0').prop('readonly',true);
            }
        });

        $(document).on('change','#ship_info', function() {
            if($(this).val() === 'div') {

            }
        });
    },


    /**
     * Set the UOM Cost for bracket and break pricing
     */
    _setUomCost: function () {
        var case_cost = $("input[name='case_cost']").val();
        var shipping_method = $("select[name='shipping_method']").val();
        var case_pack_quantity = $("input[name='case_pack_quantity']").val();
        var inner_pack_quantity = $("input[name='inner_pack_quantity']").val();
        var display_cost_override = $("input[name='display_cost_override']").val();
        var display_cost = $("input[name='display_cost']").val();
        var bracket_pricing_type  = $("#bracket_pricing_type").val();
        var break_pricing  = $("#break_pricing").val();
        var bracket_pricing  = $("#bracket_pricing").val();
        var uom_cost = 0;

        if (shipping_method != '') {
            switch (shipping_method) {
                case "CS":
                    if (case_cost != '') {
                        uom_cost = (parseFloat(case_cost)).toFixed(2);
                    }
                    break;

                case "DZ":
                    if (case_cost != '' && case_pack_quantity != '') {
                        uom_cost = ((parseFloat(case_cost) / parseFloat(case_pack_quantity)) * 12).toFixed(2);
                    }
                    break;

                case "PK":
                    if (case_cost != '' && case_pack_quantity != '' && inner_pack_quantity != '') {
                        uom_cost = ((parseFloat(case_cost) / parseFloat(case_pack_quantity)) * inner_pack_quantity).toFixed(2);
                    }
                    break;

                case "EA":
                    if (case_cost != '' && case_pack_quantity != '') {
                        uom_cost = ((parseFloat(case_cost) / parseFloat(case_pack_quantity))).toFixed(2);
                    }
                    break;

                case "DL":
                    if (display_cost_override != '') {
                        uom_cost = parseFloat(display_cost_override);
                    } else {
                        uom_cost = (parseFloat(display_cost)).toFixed(2);
                    }
                    break;
                default:
                    uom_cost = '0.00';
                    break;
            }

            if (bracket_pricing == 'Y') {
                $("input[name='bracket_break_pricing[" + bracket_pricing_type + "][1][uom_cost]").val(uom_cost);
            }
            else if (break_pricing == 'Y') {
                $("input[name='bracket_break_pricing[break][1][uom_cost]").val(uom_cost);
            }
        }
    },


    /**
     * Select the specified item form tab
     */
    _selectItemFormTab: function (index) {
        index = parseInt(index, 10);
        const isChange = abcsetup.front_store.form.current_tab !== index;
        abcsetup.front_store.form.current_tab = parseInt(index, 10);

        $('form .item-form-body div.form-div').hide();
        $('.bs-vertical-wizard li.current').removeClass('current');

        const $visibleTabs = $('.bs-vertical-wizard li:visible');
        var total = $visibleTabs.length;
        var id = $visibleTabs.eq(index).find('a').attr('href');
        var formDiv = $('form .item-form-body ' + id);
        var tabBtn = $visibleTabs.eq(index);

        // Prepend the title if needed
        if (formDiv.find('.title').length === 0) {
            formDiv.prepend('<div class="title border-bottom position-sticky sticky-top">\
                                <h1 class="mt-1 mb-3">' + tabBtn.find('a').html() + '</h1>\
                                <!--<div class="desc">' + tabBtn.find('a span').html() + '</div>-->\
                            </div>');

            formDiv.find('.title span, .title .ico').remove();
        }

        // Show the current form
        formDiv.show();

        // Format pagination
        $('li.page-item').removeClass('disabled');

        if (index === 0) {
            $('a.page-link[data-dir="prev"]').parent().addClass('disabled');
        } else if (index === total - 1) {
            $('a.page-link[data-dir="next"]').parent().addClass('disabled');
        }

        if (isChange) {
            this.removeValidationAlerts({visible: false});
        }
        tabBtn.addClass('current');
    },


    /**
     * Validate the specified tab (null for all)
     */
    _validateForm: function (index = null, init = false) {
        let dialog_html;
        let end;
        let start;
        let isValid = true;

        this.removeValidationAlerts();
        this.removeValidationOrnaments();

        // Validate all the tabs
        if (index == null) {
            start = 0;
            end = $('.bs-vertical-wizard li:visible').length;
            // Validate the specific tab
        } else {
            start = index;
            end = index;
        }

        // Loop through each tab to validate
        for (let i = start; i <= end; i++) {
            $('.bs-vertical-wizard li:visible').eq(i).removeClass('complete tab-error').find('.ico').remove();

            // Find the current tab field we're validating
            const id = $('.bs-vertical-wizard li:visible').eq(i).find('a').attr('href');
            const formDiv = $('form .item-form-body ' + id);

            // Show the current form div to enable validation
            this._selectItemFormTab(i);

            // TODO This could be replaced with:
            /*
            if (!fieldValidate.checkValidity(formDiv)) {
                isValid = false;
            }
            */
            formDiv.find(':input:visible:not(:disabled)').each(function () {
                window.fieldValidate.runValidations(this);
                if (!this.validity.valid) {
                    if (window.fieldValidate._debug) console.log('invalid:',this);
                    isValid = false;
                }
            });

            // Build a validation message and update the left hand tabs
            if (isValid) {
                dialog_html = '<div class="form_validate_feedback_dialog alert alert-success">All fields on this tab have passed validation</div>';
                $('.bs-vertical-wizard li:visible').eq(i).removeClass('current tab-error').addClass('complete').find('.ico').remove();
                $('.bs-vertical-wizard li:visible').eq(i).find('a').append('<i class="ico fa fa-check ico-green"></i>');

            } else if (!init) {
                dialog_html = '<div class="form_validate_feedback_dialog alert alert-danger">There are errors on this tab. Please review the fields highlighted in red</div>';
                $('.bs-vertical-wizard li:visible').eq(i).removeClass('current complete').addClass('tab-error').find('.ico').remove();
                $('.bs-vertical-wizard li:visible').eq(i).find('a').append('<i class="ico fas fa-times ico-red"></i>');
            }

            // Add the validation message
            if (!init) {
                this.removeValidationAlerts({visible: true, invisible: true}, formDiv);
                formDiv.find('.title').after(dialog_html);
            }

            // Stop after finding the first form field with an error
            if (!isValid && !init) {
                break;
            }
        }

        // Reset form div to the current one
        this._selectItemFormTab(this.current_tab);

        if (isValid && !init) {
            $(document).scrollTop(50);
        } else if (!isValid && !init) {
            // Form validation failed
            // We're validating all tabs, switch to the first one with an error
            if (index == null) {
                const firstTab = $('.bs-vertical-wizard li:visible').index($('.bs-vertical-wizard li:visible.tab-error'));
                this._selectItemFormTab(firstTab);
            }

            // $('#hidden_submit').click();

            // TODO We should be okay to remove this.
            $('.invalid:visible:first').trigger('focus');

            if (index !== null) {
                this.removeValidationOrnaments({visible: false});
                this.removeValidationAlerts({visible: false});
            }

            if ($('.invalid:visible:first').hasClass("readonly")) {
                $('.invalid:visible:first').blur();
            }
        }

        return isValid;
    },

    /**
     * Validate the specified tab (null for all)
     */
    _validateFormGRxAnalyst: function (index = null, init = false) {
        let dialog_html;
        let end;
        let start;
        let isValid = true;

        this.removeValidationAlerts();
        this.removeValidationOrnaments();
        // Validate all the tabs
        if (index == null) {
            start = 0;
            end = $('.bs-vertical-wizard li:visible').length;
            // Validate the specific tab
        } else {
            start = index;
            end = index;
        }

        // Loop through each tab to validate
        for (let i = start; i <= end; i++) {
            $('.bs-vertical-wizard li:visible').eq(i).removeClass('complete tab-error').find('.ico').remove();

            // Find the current tab field we're validating
            const id = $('.bs-vertical-wizard li:visible').eq(i).find('a').attr('href');
            const formDiv = $('form .item-form-body ' + id);

            if (id == '#tab_product-detail') {
                // Show the current form div to enable validation
                this._selectItemFormTab(i);

                window.fieldValidate.runValidations($('#vendor'));
                if ($('#vendor').val() == "") {
                    isValid = false;
                }

                // Build a validation message and update the left hand tabs
                if (isValid) {
                    dialog_html = '<div class="form_validate_feedback_dialog alert alert-success">All fields on this tab have passed validation</div>';
                    $('.bs-vertical-wizard li:visible').eq(i).removeClass('current tab-error').addClass('complete').find('.ico').remove();
                    $('.bs-vertical-wizard li:visible').eq(i).find('a').append('<i class="ico fa fa-check ico-green"></i>');

                } else if (!init) {
                    dialog_html = '<div class="form_validate_feedback_dialog alert alert-danger">There are errors on this tab. Please review the fields highlighted in red</div>';
                    $('.bs-vertical-wizard li:visible').eq(i).removeClass('current complete').addClass('tab-error').find('.ico').remove();
                    $('.bs-vertical-wizard li:visible').eq(i).find('a').append('<i class="ico fas fa-times ico-red"></i>');
                }

                // Add the validation message
                if (!init) {
                    this.removeValidationAlerts({visible: true, invisible: true}, formDiv);
                    formDiv.find('.title').after(dialog_html);
                }

                // Stop after finding the first form field with an error
                if (!isValid && !init) {
                    break;
                }
            }
        }

        // Reset form div to the current one
        this._selectItemFormTab(this.current_tab);

        if (isValid && !init) {
            $(document).scrollTop(50);
        } else if (!isValid && !init) {
            // Form validation failed
            // We're validating all tabs, switch to the first one with an error
            if (index == null) {
                const firstTab = $('.bs-vertical-wizard li:visible').index($('.bs-vertical-wizard li:visible.tab-error'));
                this._selectItemFormTab(firstTab);
            }

            // $('#hidden_submit').click();

            // TODO We should be okay to remove this.
            $('.invalid:visible:first').trigger('focus');

            if (index !== null) {
                this.removeValidationOrnaments({visible: false});
            }
        }

        return isValid;
    },

    removeValidationAlerts({invisible = true, visible = true} = {}, context) {
        context = context || document;

        if (visible) {
            $(context).find('.form_validate_feedback_dialog:visible').remove();
        }

        if (invisible) {
            $(context).find('.form_validate_feedback_dialog:not(:visible)').remove();
        }
    },

    removeValidationOrnaments({invisible = true, visible = true} = {}) {
        visible && window.fieldValidate.removeOrnaments($('.invalid:visible'));
        invisible && window.fieldValidate.removeOrnaments($('.invalid:not(:visible)'));
    },
}
